import { MenuPlacement } from "@growtherapy/sprout-ui";

export const DEFAULT_POPOVER_PLACEMENT: MenuPlacement = "top";
export const DEFAULT_POPOVER_GAP = "1.25rem";
